import styled from "@emotion/styled";

import { color } from "metabase/lib/colors";
import BreakoutPopover from "metabase/query_builder/components/BreakoutPopover";

export const StyledBreakoutPopover = styled(BreakoutPopover)`
  color: ${color("brand")};
`;
